import axios from 'axios';
import Swal from 'sweetalert2';
import { aesUtil } from './aesUtil';

const toBeEncrypted = process.env.REACT_APP_ENCRYPTION === 'true';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    config.headers.JWT = 'JWT';
    // Encrypt request body using AES encryption
    if (toBeEncrypted) {
      const encryptedData = aesUtil.encrypt(JSON.stringify(config.data));
      config.data = {
        data: encryptedData
      };
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => {
    Promise.reject(new Error(error));
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (toBeEncrypted) {
      if (response.data) {
        let res = response.data
        const decryptedData = aesUtil.decrypt(res);
        response.data = JSON.parse(decryptedData);
      }
    }
    return response;
  },
  async (error) => {
    if (toBeEncrypted) {
      let res = error.response.data;
      const decryptedError = aesUtil.decrypt(res);
      error.response.data = JSON.parse(decryptedError);
    }
    if (error.response && (error.response.status === 403)) {
      Swal.fire({
        title: "You don't have permission to access this module!",
        icon: 'info',
        showCancelButton: false,
        allowOutsideClick: false,
        confirmButtonColor: '#1B2354',
        confirmButtonText: 'OK',
        timer: 60000,
        timerProgressBar: true,
        customClass: 'sweet-alert',
        willClose: () => {
          window.location.reload();
        }
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('You clicked OK');
          window.location.href = "/admin/dashboard";
        }
      })
    }
    else if (error.response && (error.response.status === 401)) {
      localStorage.clear();
      Swal.fire({
        title: 'Your session has expired. Please login!',
        icon: 'info',
        showCancelButton: false,
        allowOutsideClick: false,
        confirmButtonColor: '#1B2354',
        confirmButtonText: 'OK',
        timer: 60000,
        timerProgressBar: true,
        customClass: 'sweet-alert',
        willClose: () => {
          window.location.reload();
        }
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      })
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
